import styled from 'styled-components';

import { colors, breakpoints } from '../../../styles/variables';
import { SText } from '../../atoms/Typography/Text/styles';

export const STilesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 3rem;
    row-gap: 1.6rem;
    width: 100%;

    @media (min-width: ${ breakpoints.medium }) {
        grid-template-columns: 1fr 1fr;
        row-gap: 2.4rem;
    }
`;

export const STileItem = styled.div`
    background-color: ${
        ({ background }) => background || colors.white
    };

    border-radius: 1.6rem;
    padding: 2.4rem 2.4rem 6.6rem;
    box-sizing: border-box;
    position: relative;

    @media (min-width: ${ breakpoints.medium }) {
        padding: 4rem 4rem 8.2rem;
    }
`;

export const STileText = styled(SText)`
    display: flex;
    margin-bottom: 2.4rem;
    color: ${ colors.blackLowContrast };
`;

export const SCtaContainer = styled.div`
    position: absolute;
    left: 2.4rem;
    bottom: 2.4rem;
    right: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 4.2rem;

    @media (min-width: ${ breakpoints.medium }) {
        left: 4rem;
        bottom: 4rem;
        right: 4rem;
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const SCtaAction = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 32rem;
    text-decoration: none;

    @media (min-width: ${ breakpoints.medium }) {
        width: initial;
        height: initial;
    }
`;
